export default __webpack_public_path__ + "images/loading.17abe3b575d44ec9827469a09c33a885.gif";